import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, imgSrc } from "../lib/api";
import { money } from "../lib/shop";
import { SectionTitle } from "../components/site/Decor";

export const ShopGrid = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/shop").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <section id="shop" className="scroll-mt-28 bg-[#FFF4F8]" data-testid="shop-section">
      <div className="mx-auto max-w-7xl px-6 pt-16">
        <SectionTitle eyebrow="Shop" title="Ready to" script="order" />
        <p className="mt-4 max-w-2xl text-[#0E0B0D]/70">Set prices, your choice of color, size and design. Pay securely online. Want something one-of-a-kind? <Link to="/order" className="font-semibold text-[#FF1F8E]">Request a custom quote</Link>.</p>
      </div>
      <div className="mx-auto grid max-w-7xl gap-6 px-6 py-14 sm:grid-cols-2 lg:grid-cols-4" data-testid="shop-grid">
        {items?.map((it) => (
          <Link key={it.id} to={`/shop/${it.id}`} className="group overflow-hidden rounded-3xl bg-white ring-1 ring-[#EBD08A] transition-transform hover:-translate-y-1" data-testid={`shop-item-${it.id}`}>
            {imgSrc(it) && <img src={imgSrc(it)} alt={it.name} className="aspect-square w-full object-cover" />}
            <div className="p-5">
              <h2 className="font-display text-lg font-bold">{it.name}</h2>
              <p className="mt-1 font-display text-2xl font-black text-[#FF1F8E]">{money(it.price)}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold">Choose options <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
            </div>
          </Link>
        ))}
        {items?.length === 0 && <p className="col-span-full py-10 text-center text-black/60" data-testid="shop-empty">New items are coming soon. <Link to="/order" className="font-semibold text-[#FF1F8E]">Request a custom order</Link></p>}
      </div>
    </section>
  );
};
